module.exports = __webpack_public_path__ + "img/dve-strely-po-dvojite-vymene-micku.9293455a.jpg";